import { PasswordValidation } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { SettingsContent } from 'modules/settings/common/components';

import { PasswordField } from './PasswordField';

interface PasswordSettingsProps {
  passwordValidation: PasswordValidation;
}

export const PasswordSettings = ({
  passwordValidation,
}: PasswordSettingsProps) => {
  const { t } = useTranslation();

  return (
    <SettingsContent
      leftContent={
        <Stack justifyContent="space-between" spacing={8}>
          <Typography variant="bodyBold">
            {t('settings.password.title')}
          </Typography>
          <Typography lineHeight="140%">
            {t('settings.password.subtitle')}
          </Typography>
        </Stack>
      }
      rightContent={
        <>
          <PasswordField
            passwordType="oldPassword"
            passwordValidation={passwordValidation}
          />
          <PasswordField
            passwordType="newPassword"
            passwordValidation={passwordValidation}
          />
        </>
      }
    />
  );
};
